
import { createFeature, createReducer, on } from '@ngrx/store';
import { AiChatActions, DataOperationEvent } from '@rapider/ai-chat';
import { DatabaseActions } from './database.actions';

export interface DataHistoryState {
  events: DataOperationEvent[];
  dataCardTemplates: Record<string, string>;
}

export const initialDataHistoryState: DataHistoryState = {
  events: [],
  dataCardTemplates: {}
};

/**
 * Feature state dedicated to tracking the chronological history of data operations
 * and caching generated AI templates for UI elements like Data Cards.
 * Actively intercepts cross-domain actions fired from the AI Chat to map real-time timelines.
 */
export const dataHistoryFeature = createFeature({
  name: 'dataHistory',
  reducer: createReducer(
    initialDataHistoryState,
    on(AiChatActions.logDataOperation, (state, { event }) => ({
      ...state,
      // Prepend the new event so the most recent operation is at the top of the history list
      events: [event, ...state.events]
    })),
    on(DatabaseActions.setDataCardTemplate, (state, { projectModelName, template }) => ({
      ...state,
      dataCardTemplates: {
        ...state.dataCardTemplates,
        [projectModelName]: template
      }
    }))
  )
});

export const { selectDataHistoryState, selectEvents, selectDataCardTemplates } = dataHistoryFeature;